import { CapoPlugin } from "/codebuild/output/src3183640832/src/consort-headless/nuxtapp/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];